// extracted by mini-css-extract-plugin
export default {"fondoLogin":"LoginScreenComponent_fondoLogin__p9S33"};